import { useCallback, useState } from 'react';

import type { AppNotification, UseNotificationsResult } from './notifications.types';

/**
 * Default notifications source: nothing to load. Dashboards plug a real one
 * through `AppDefinition.notifications` (backend, socket or Redux backed).
 */
export function useEmptyNotifications(): UseNotificationsResult {
  const [items, setItems] = useState<AppNotification[]>([]);

  const loadList = useCallback(() => {
    // No source configured for this app.
  }, []);

  const markAsRead = useCallback((id: string) => {
    setItems((prev) =>
      prev.map((n) =>
        n.id === id ? { ...n, read_at: new Date().toISOString() } : n,
      ),
    );
  }, []);

  const unreadCount = items.filter((n) => !n.read_at).length;

  return { items, unreadCount, loadList, markAsRead };
}
